// src/main.jsx

import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { Amplify } from 'aws-amplify'
import React from 'react'
import ReactDOM from 'react-dom/client'
import awsConfig from '@/data/config/aws-config'
import { ThemeProvider, UnitsProvider, useThemeMode } from '@/features/shared-ui'
import App from './App'

// Import translation debug utility for development only
if (import.meta.env.DEV) {
  import('./utils/debugTranslation.js')
}

// Configure Amplify with AWS credentials
Amplify.configure(awsConfig)

// Inner component that uses the theme from context
function ThemedApp() {
  const { theme } = useThemeMode()

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </MuiThemeProvider>
  )
}

// Removed console logging - use React Query DevTools or network tab for debugging

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider>
      <UnitsProvider>
        <ThemedApp />
      </UnitsProvider>
    </ThemeProvider>
  </React.StrictMode>
)
